// extracted by mini-css-extract-plugin
export default {"container":"iZJdpbzB","content":"JAm8QTX8","title":"qc31mLAj","fadeIn":"IBSl0nZ_","message":"k2xVSR4F","description":"y_NJMhDo","button":"vYsKZ9vj"};